import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { BatchType } from '../../../app/models/BatchType';
import BatchTypeForm from './forms/BatchTypeForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    batchType: BatchType;
    setBatchType: (batchType: BatchType) => void;
    errorFields?: any;
}

const BatchTypeFormContainer = ({
    fetching,
    action,
    cancel,
    batchType,
    setBatchType,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <BatchTypeForm
                        batchTypeDataForm={batchType}
                        setBatchTypeDataForm={setBatchType}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default BatchTypeFormContainer;
